export default __webpack_public_path__ + "static/media/underconstruction.2416b408.png";